<template>

  <div>

    <Collapsable
      :collapsed="collapsed"
      :title="$t('licenses.payments.title')"
    >

      <span slot="beforeCollapse" class="d-flex align-items-center">

        <Searchable
          class="mr-1"
          :querySearch.sync="querySearch" />

      </span>

      <TableView
        ref="paymentsTable"
        :license="license"
        @paymentSelected="onPaymentSelected" />

      <div class="d-flex justify-content-end">
        <va-button
          v-if="hasWritePermissions && license.invoice_amount && !licenseIsFullyPaid"
          @click.prevent="createPayment">
          {{$t('licenses.payments.create')}}
        </va-button>
      </div>

      <CreateOrUpdate
        v-if="showPaymentModal"
        :license="license"
        :payment="selectedPayment"
        @created="onPaymentCreated"
        @updated="onPaymentUpdated"
        @destroyed="onPaymentDestroyed"
        @modalClosed="onPaymentModalClosed" />

    </Collapsable>

  </div>
</template>

<script>
import Searchable from '@/components/common/Searchable'
import Collapsable from '@/components/common/Collapsable'
import TableView from './TableView'
import CreateOrUpdate from './CreateOrUpdate'
const licenseInfoType = 300
const WriteAccessType = 2
export default {
  components: {
    TableView,
    Searchable,
    Collapsable,
    CreateOrUpdate
  },
  props: {
    license: {
      type: Object,
      requred: true
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollead_server)
    },
    hasWritePermissions: function () {
      return this.leadsService.user_permissions.some(permission => permission.info_type === licenseInfoType && permission.access_type >= WriteAccessType)
    },
    licenseIsFullyPaid: function () {
      if (!this.license.invoice_amount) {
        return true
      } else {
        return this.license.amount_payed >= this.license.invoice_amount
      }
    }
  },
  data: function () {
    return {
      showPaymentModal: false,
      selectedPayment: undefined,
      querySearch: ''
    }
  },
  methods: {
    createPayment: function () {
      this.showPaymentModal = true
    },
    onPaymentModalClosed: function () {
      this.showPaymentModal = false
    },
    onPaymentSelected: function (payment) {
      this.selectedPayment = payment
      this.showPaymentModal = true
    },
    onPaymentCreated: function (payment) {
      this.showPaymentModal = false
      this.selectedPayment = undefined
      this.$emit('paymentCreated')
    },
    onPaymentUpdated: function (payment) {
      this.showPaymentModal = false
      this.selectedPayment = undefined
      this.$emit('paymentUpdated')
    },
    onPaymentDestroyed: function (payment) {
      this.showPaymentModal = false
      this.selectedPayment = undefined
      this.$emit('paymentDestroyed')
    },
  },
  watch: {
    querySearch: function (search) {
      this.$refs.paymentsTable.setFilter(search)
    }
  }
}
</script>
